import {gql} from 'apollo-angular';


export interface DossierLink {
  id?: number;
  dossierId: number;
  toDossierId: number;
  name: string;
  internationalTrainNr: string;
  dossierTitle: string;
}

export const dossierLink = gql`
  fragment dossierLink on DossierLink {
    id,
    dossierId,
    toDossierId,
    name,
    internationalTrainNr,
    dossierTitle
  }`;



